import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.default,
    padding: "20px",
    borderRadius: 5,
    boxSizing: "border-box",
    "& h4, p": {
      margin: 0
    },
    "& h4": {
      marginBottom: 14,
      display: "inline-block"
    }
  },
}));

interface LabelProps {
  heading: string;
  content: string;
  isOpen: boolean;
  handleClose?: () => void;
}

export const WarningModal: React.FC<LabelProps> = (props: LabelProps) => {
  const {
    heading, content, isOpen, handleClose
  } = props;


  const classes = useStyles();

  return (
    <Modal
      className={classes.modal}
      open={isOpen}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <div className={classes.paper}>
          <b><h4 id="transition-modal-title">{heading}</h4></b>
          <p id="transition-modal-description">{content}</p>
        </div>
      </Fade>
    </Modal>
  );
}

export default WarningModal